import React from 'react';
import { useTranslation } from 'react-i18next';

const PortfolioStructureHeader = ({ PortfolioStructureHeaderLabels, asOfDateFormatted }) => {
  const { t } = useTranslation();
  return (
    <div className="l-grid__row justify-content-center">
      <div className="l-grid__column-large-8 l-grid__column-medium-10 u-text-align-center">
        {/* eslint-disable-next-line */}
        <a name="PortfolioStructure">
          <h2 className="c-heading u-margin-bottom-m" tabIndex="0">
            {PortfolioStructureHeaderLabels?.headline}
          </h2>
        </a>
        <p className="c-copy u-margin-bottom-2m" tabIndex="0">
          {t('asOfDateLabel')} {asOfDateFormatted}
        </p>
        <p className="c-copy u-margin-bottom-none" tabIndex="0">
          {PortfolioStructureHeaderLabels?.subHeadline}
        </p>
      </div>
    </div>
  );
};

export default PortfolioStructureHeader;